import React, { useContext, useEffect } from "react";
import { ChatbotContext } from "@/store/context/ChatbotContext.tsx";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/shadcn/card.tsx";

import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/components/shadcn/tabs";

import { useTranslation } from "react-i18next";
import LeadsSettings from "@/pages/chatbot/leads/LeadsSettings.tsx";
import { LeadsTable } from "@/pages/chatbot/leads/LeadsTable.tsx";
import {Icon} from "@/components/Icon.tsx";
import LeadsNotifications from "@/pages/chatbot/leads/LeadsNotifications.tsx";
import LeadsWebhook from "@/pages/chatbot/leads/LeadsWebhook.tsx";

export default function LeadsPage() {
  const { t } = useTranslation();

  return (
    <Card className="">
      <CardHeader>
        <CardTitle>{t("sidebar.leads")}</CardTitle>
        <CardDescription></CardDescription>
      </CardHeader>
      <CardContent>
        <Tabs defaultValue="leads">
          <TabsList className="grid w-full grid-cols-4">
            <TabsTrigger value="leads">{t("sidebar.leads")}</TabsTrigger>
            <TabsTrigger value="settings">
              <Icon
                className="inline-block mr-1"
                icon="ic:outline-settings"
                width={20}
              />
              {t("settings")}
            </TabsTrigger>
            <TabsTrigger value="notifications">
              <Icon
                className="inline-block mr-1"
                icon="ic:outline-notifications-active"
                width={20}
              />
              {t("leads.notifications")}
            </TabsTrigger>
            <TabsTrigger value="webhook">
              <Icon
                className="inline-block mr-1"
                icon="ic:baseline-webhook"
                width={20}
              />
              {t("leads.webhook")}
            </TabsTrigger>
          </TabsList>
          <TabsContent value="leads" className="mt-6">
            <LeadsTable />
          </TabsContent>
          <TabsContent value="settings">
            <LeadsSettings />
          </TabsContent>
          <TabsContent value="notifications">
            <LeadsNotifications />
          </TabsContent>
          <TabsContent value="webhook">
            <LeadsWebhook />
          </TabsContent>
        </Tabs>
      </CardContent>
      <CardFooter className="flex justify-between"></CardFooter>
    </Card>
  );
}
